import {
  configureInsightsTracking,
  initInsights,
  logErrorToInsights,
  logEventToInsights,
} from '../components/common/applicatonInsights';
import {
  configureSentryTracking,
  initSentry,
  logErrorToSentry,
  logEventToSentry,
} from '../components/common/sentry';
import { AppSettings } from './appSettings';
import { PAYMENT_IDENTIFIER_NAME } from './identifiers';
import { syncClarityWithAnalyticsConsent } from './oneTrustConsent';
import { getPublicIp, getQueryParam } from './utils';

export interface EventLog {
  message: string;
  extra?: any;
  level: 'debug' | 'info' | 'warning' | 'error' | 'fatal';
}

export enum EntityType {
  payment = 'payment',
  subscription = 'subscription',
  instalmentPlan = 'instalmentPlan',
}

export const initializeLogging = (settings: AppSettings) => {
  const paymentId =
    getQueryParam(PAYMENT_IDENTIFIER_NAME) || localStorage.getItem(PAYMENT_IDENTIFIER_NAME) || '';

  let cleanup: (() => void) | undefined;

  if (settings.appInsights.isEnabled) {
    initInsights(settings, paymentId);
  }

  if (settings.sentry.isEnabled) {
    getPublicIp()
      .then((ip) => {
        initSentry(settings, ip, paymentId);
      })
      .catch(() => {
        initSentry(settings, '0.0.0.0', paymentId);
      });
  }

  if (settings.clarity.isEnabled) {
    cleanup = syncClarityWithAnalyticsConsent(settings.clarity.projectId);
  }

  return cleanup;
};

export const configureTrackingProps = (
  entityId: string,
  entityType: EntityType,
  correlationSessionId: string
) => {
  configureInsightsTracking(entityId, entityType, correlationSessionId);
  configureSentryTracking(entityId, entityType, correlationSessionId);
};

export const logError = (exception: any) => {
  try {
    logErrorToInsights(exception);
  } catch {
    // logging should not causing any error
  }

  try {
    logErrorToSentry(exception);
  } catch {
    // logging should not causing any error
  }
};

export const logEvent = (event: EventLog) => {
  try {
    logEventToInsights(event);
  } catch {
    // logging should not causing any error
  }

  try {
    logEventToSentry(event);
  } catch {
    // logging should not causing any error
  }
};
